import React from 'react';

import { Box } from '@mui/material';
import { PrescripteurApi } from '@europrocurement/l2d-domain';
import { UserStructureDetailsForm } from '../UserStructureDetailsForm/UserStructureDetailsForm';
import { DetailsViewEditButton } from '../DetailsViewEditButton/DetailsViewEditButton';

export type UserStructureDetailsProps = {
    prescriber?: PrescripteurApi;
};

export const UserStructureDetails: React.FunctionComponent<UserStructureDetailsProps> = function ({
    prescriber,
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 4,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        width: '100%',
                        gap: 4,
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                        }}
                    >
                        <UserStructureDetailsForm prescriber={prescriber} />
                    </Box>
                </Box>
                <DetailsViewEditButton
                    label="Demander la modification des informations de ma société"
                    href="https://www.legal2digital.fr/contactez-nous/?origine=13&demande=infos-societe"
                    openInNewTab
                />
            </Box>
        </Box>
    );
};
